import { render } from "./mobileMenu.vue?vue&type=template&id=65ba9996&scoped=true"
import script from "./mobileMenu.vue?vue&type=script&lang=js"
export * from "./mobileMenu.vue?vue&type=script&lang=js"

import "./mobileMenu.vue?vue&type=style&index=0&id=65ba9996&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ba9996"]])

export default __exports__